(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["site-map-navigation"] && !Shopify.designMode) return;
  try {
    
    document
        .querySelectorAll(".site-map-navigation__view-all-btn")
        .forEach((button) => {
            button.addEventListener("click", () => {
                const category = button.closest(
                    ".site-map-navigation__category"
                );
                const isExpanded = category.classList.toggle(
                    "site-map-navigation__category--expanded"
                );

                const yOffset = -100;
                const y =
                    category.getBoundingClientRect().top +
                    window.pageYOffset +
                    yOffset;

                window.scrollTo({
                    top: y,
                    behavior: "smooth"
                });
            });
        });

  } catch(e) { console.error(e); }
})();
})();
